import React from "react";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { useGetCategoriesQuery } from "slices/beautyApp/categorySlice";

import {
  useGetProductSubCatQuery,
  useGetProductServiceTypesQuery,
} from "slices/beautyApp/productSlice";

function BasicInfoSection({ formData, handleFieldChange, itemMode, errors, touched }) {
  const { data, isLoading, refetch } = useGetCategoriesQuery({});

  const { data: subCatData, isFetching: subCatLoading } =
    useGetProductSubCatQuery(formData.category, {
      skip: !formData.category,
    });

  const { data: serviceTypeData, isFetching: typeLoading } =
    useGetProductServiceTypesQuery(formData.subCategory, {
      skip: !formData.subCategory,
    });

  return (
    <>
      {/* Category Select */}
      <FormControl 
        fullWidth 
        margin="normal" 
        required
        error={touched.category && Boolean(errors.category)}
      >
        <InputLabel id="category-label">Category</InputLabel>
        <Select
          labelId="category-label"
          value={formData.category || ""}
          onChange={(e) => {
            handleFieldChange("category", e.target.value);
            handleFieldChange("subCategory", "");
            handleFieldChange("subCategoryType", "");
          }}
          label="Category"
        >
          {data?.data.map((category) => (
            <MenuItem key={category._id} value={category._id}>
              {category.name}
            </MenuItem>
          ))}
        </Select>
        {touched.category && errors.category && (
          <FormHelperText error>{errors.category}</FormHelperText>
        )}
      </FormControl>

      {/* SubCategory Select */}
      <FormControl 
        fullWidth 
        margin="normal" 
        required
        error={touched.subCategory && Boolean(errors.subCategory)}
      >
        <InputLabel id="subcategory-label">SubCategory</InputLabel>
        <Select
          labelId="subcategory-label"
          value={formData.subCategory || ""}
          onChange={(e) => {
            handleFieldChange("subCategory", e.target.value);
            handleFieldChange("subCategoryType", "");
          }}
          label="SubCategory"
        >
          {subCatData?.data?.map((sub) => (
            <MenuItem key={sub._id} value={sub._id}>
              {sub.name}
            </MenuItem>
          ))}
        </Select>
        {touched.subCategory && errors.subCategory && (
          <FormHelperText error>{errors.subCategory}</FormHelperText>
        )}
      </FormControl>

      {/* Types Select */}
      <FormControl 
        fullWidth 
        margin="normal" 
        required
        error={touched.subCategoryType && Boolean(errors.subCategoryType)}
      >
        <InputLabel id="type-label">Type</InputLabel>
        <Select
          labelId="type-label"
          value={formData.subCategoryType || ""}
          onChange={(e) => handleFieldChange("subCategoryType", e.target.value)}
          label="Type"
        >
          {serviceTypeData?.data?.map((type) => (
            <MenuItem key={type._id} value={type._id}>
              {type.name}
            </MenuItem>
          ))}
        </Select>
        {touched.subCategoryType && errors.subCategoryType && (
          <FormHelperText error>{errors.subCategoryType}</FormHelperText>
        )}
      </FormControl>

      {/* Other Inputs */}
      <TextField
        label="Title"
        value={formData.name}
        onChange={(e) => handleFieldChange("name", e.target.value)}
        fullWidth
        margin="normal"
        required
        error={touched.name && Boolean(errors.name)}
        helperText={touched.name && errors.name}
      />

      <TextField
        label="Sub Title"
        value={formData.sub_title}
        onChange={(e) => handleFieldChange("sub_title", e.target.value)}
        fullWidth
        margin="normal"
        required
        error={touched.sub_title && Boolean(errors.sub_title)}
        helperText={touched.sub_title && errors.sub_title}
      />

      {itemMode === "single" && (
        <>
          <TextField
            label="Duration"
            type="number"
            value={formData.duration}
            onChange={(e) => handleFieldChange("duration", e.target.value)}
            fullWidth
            margin="normal"
            required
            error={touched.duration && Boolean(errors.duration)}
            helperText={touched.duration && errors.duration}
          />
          <TextField
            type="number"
            label="Service Price"
            value={formData.servicePrice}
            onChange={(e) => handleFieldChange("servicePrice", e.target.value)}
            fullWidth
            margin="normal"
            required
            error={touched.servicePrice && Boolean(errors.servicePrice)}
            helperText={touched.servicePrice && errors.servicePrice}
          />

          <TextField
            type="number"
            label="Off Percentage"
            value={formData.off_percentage}
            onChange={(e) =>
              handleFieldChange("off_percentage", e.target.value)
            }
            fullWidth
            margin="normal"
            error={touched.off_percentage && Boolean(errors.off_percentage)}
            helperText={touched.off_percentage && errors.off_percentage}
          />
        </>
      )}
    </>
  );
}

export default BasicInfoSection;